import { useEffect, useMemo } from 'react';
import { DemeterCommodity } from '../../../../../../Generated/Raven-Demeter';
import CheckboxDropdown from '../../../../../Components/Form/Inputs/CheckboxDropdown';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import { LiquidityRiskCalculationInputs } from '../../../RiskDefinitions';
import styles from '../../InsuranceQuoteEstimator.module.scss';

interface ILiquidityRiskTypeDropdownProps {
    calculationInputs: LiquidityRiskCalculationInputs;
    setCalculatorInputs: (value: LiquidityRiskCalculationInputs) => void;
}

const LiquidityRiskTypeDropdown: React.FC<ILiquidityRiskTypeDropdownProps> = (props: ILiquidityRiskTypeDropdownProps) => {
    const [translations] = useLanguage();

    const typeOptions = useMemo(() => {
        if (props.calculationInputs.commodity === DemeterCommodity.CattleFeeder) {
            return [
                {
                    label: translations.commodity[DemeterCommodity.CattleSteerWeight1],
                    value: DemeterCommodity.CattleSteerWeight1,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleSteerWeight2],
                    value: DemeterCommodity.CattleSteerWeight2,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleHeiferWeight1],
                    value: DemeterCommodity.CattleHeiferWeight1,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleHeiferWeight2],
                    value: DemeterCommodity.CattleHeiferWeight2,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleBrahmanWeight1],
                    value: DemeterCommodity.CattleBrahmanWeight1,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleBrahmanWeight2],
                    value: DemeterCommodity.CattleBrahmanWeight2,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleDairyWeight1],
                    value: DemeterCommodity.CattleDairyWeight1,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleDairyWeight2],
                    value: DemeterCommodity.CattleDairyWeight2,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleSteerAndHeiferUnborn],
                    value: DemeterCommodity.CattleSteerAndHeiferUnborn,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleBrahmanUnborn],
                    value: DemeterCommodity.CattleBrahmanUnborn,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleDairyUnborn],
                    value: DemeterCommodity.CattleDairyUnborn,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleCalvesUnborn],
                    value: DemeterCommodity.CattleCalvesUnborn,
                },
            ];
        }

        if (props.calculationInputs.commodity === DemeterCommodity.CattleLive) {
            return [
                {
                    label: translations.commodity[DemeterCommodity.CattleSteerAndHeifer],
                    value: DemeterCommodity.CattleSteerAndHeifer,
                },
                {
                    label: translations.commodity[DemeterCommodity.CattleCullCow],
                    value: DemeterCommodity.CattleCullCow,
                },
            ];
        }

        return [
            {
                label: translations.commodity[DemeterCommodity.LeanHogUnborn],
                value: DemeterCommodity.LeanHogUnborn,
            },
            {
                label: translations.commodity[DemeterCommodity.Unknown],
                value: DemeterCommodity.Unknown,
            },
        ];
    }, [props.calculationInputs.commodity, translations]);

    useEffect(() => {
        props.setCalculatorInputs({ ...props.calculationInputs, type: [] });
    }, [props.calculationInputs.commodity]);

    return (
        <div className={styles.liquidity_risk_type_dropdown}>
            <CheckboxDropdown
                labelType="selectedTextValues"
                placeholder={props.calculationInputs.type.length === 0 ? translations.words.select : ''}
                values={props.calculationInputs.type}
                options={typeOptions}
                handleOptionSelect={(value) => props.setCalculatorInputs({ ...props.calculationInputs, type: value })}
                label={translations.risk.margin.fields.type}
                track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'LivestockTypeChanged', eventValue: props.calculationInputs.type }}
            />
        </div>
    );
};

export default LiquidityRiskTypeDropdown;
